import Parse from 'parse'
import {ParseDbService, thumbnailSchema as Schema} from "./parse.db.service";
import Axios from "axios";

function getAll(pagination, search) {
    let query = new Parse.Query(ParseDbService.ThumbnailClassName);
    if (pagination) {
        query.skip((pagination.page - 1) * pagination.perPage)
            .limit(pagination.perPage)
    }
    query.withCount(true);

    if (search !== undefined && search != null && search.length !== 0) {
        query.contains(Schema.name, search);
    }

    return query.find().then(items => {
        return {
            results: items.results.map(item => {
                return {
                    parseItem: item,
                    name: item.get(Schema.name),
                    thumbnail: item.get(Schema.image)
                }
            }),
            count: items.count
        }
    });
}


function add(item) {
    let file = new Parse.File(item.name.toLowerCase(), item.thumbnail);
    return file.save(null).then((parseFile)=>{
        let ClassItem = Parse.Object.extend(ParseDbService.ThumbnailClassName, null, null);
        let classObj = new ClassItem();
        classObj.set(Schema.name, item.name.toLowerCase());
        classObj.set(Schema.image, parseFile);
        return classObj.save();
    });
}

function download(url, name) {
    Axios.get(url, {
        responseType: 'arraybuffer'
    }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'image/*'}));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);//or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    });
}


function edit(item) {
    let classObj = item.parseItem;
    classObj.set(Schema.name, item.name.toLowerCase());
    return classObj.save();
}

export const ThumbnailService = {
    getAll,
    add,
    edit,
    download
};

